import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker, {unregister} from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

createRoot(rootElement).render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>
);

unregister()
